import ConditionalWrapper from 'components/ConditionalWrapper'
import PathChoiceFieldGroup from 'components/PathChoiceFieldGroup'
import { observer } from 'mobx-react'
import { memo, useEffect } from 'react'
import { useStores } from 'stores/utils/hooks/useStores'
import { CivilStatus } from 'utils/formDependencies/statics/enums/CivilStatus'

interface Props {
  dependson?: string
}

const DebtorRelationship = observer(({ dependson }: Props) => {
  const {
    traversal: {
      handleMultiplePathFormFieldChanges,
      data: {
        debtors: { relationship }
      }
    }
  } = useStores()

  useEffect(
    () => {
      if (relationship === 'SPOUSE') {
        const newCivilStatus = CivilStatus.MARRIED

        handleMultiplePathFormFieldChanges([
          {
            path: `debtors.primary.personal.civilStatus`,
            value: newCivilStatus
          },
          {
            path: `debtors.secondary.personal.civilStatus`,
            value: newCivilStatus
          }
        ])
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [relationship]
  )

  return (
    <ConditionalWrapper dependson={dependson}>
      <PathChoiceFieldGroup path="debtors.relationship" />
    </ConditionalWrapper>
  )
})

export default memo(DebtorRelationship)
